<template>
  <div v-if="userInfo && configAccess" class="account-page">
    <Header />
    <div class="account-page__wrap">
      <router-view class="page" />
    </div>
    <transition name="fade">
      <Popup
        v-if="currentPopup.state"
        ref="popup"
        :popup="currentPopup.name"/>
    </transition>
    <notifications />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Header from "./components/Header";
import Popup from "@/elements/Popup/Popup";

export default {
  name: 'Account',
  
  components: {
    Header,
    Popup,
  },

  computed: {
    ...mapState({
      currentPopup: state => state.common.currentPopup,
      userInfo: state => state.user.userInfo,
      configAccess: state => state.user.configAccess,
      navigation: state => state.account.navigation,
    }),
  },

  methods: {
    ...mapActions('user', [
      'setCompanies',
    ]),
  },

  watch: {
    navigation(val) {
      if (val && this.$route.name === 'account') {
        const menu = this.navigation;

        if (menu.length) {
          if (menu[0].items && menu[0].items.length) {
            if (menu[0].items[0].tab) {
              this.$router.push({
                'name': menu[0].items[0].link,
                'query': {
                  'tab': menu[0].items[0].tab
                }
              });
            } else {
              this.$router.push({'name': menu[0].items[0].link})
            }
          } else {
            this.$router.push({'name': menu[0].link})
          }
        } else {
          this.$router.push('/');
        }
      }
    }
  },

  created() {
    this.setCompanies();
  },
};
</script>

<style scoped lang="scss">
.account-page {
  height: 100%;
  position: relative;
  color: #000;

  @media(max-width: $desktop) {
    height: auto;
    min-height: 100%;
    padding: 0 20px;
  }

  &__wrap {
    padding-top: 57px;
    height: 100%;

    @media(max-width: $desktop) {
      padding-top: 73px;
    }
  }

  ::v-deep .multiselect__single,
  ::v-deep .multiselect__input,
  ::v-deep .multiselect__placeholder,
  ::v-deep .multiselect__option {
    color: #000;
  }

  ::v-deep .multiselect__option--selected.multiselect__option--selected {
    color: #539FBB;
  }
}
</style>
